import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportpooldataComponent } from './importpooldata.component';
import { ShareModule } from 'src/app/share.module';



@NgModule({
  declarations: [
    ImportpooldataComponent
  ],
  imports: [
    CommonModule,
    ShareModule
  ]
})
export class ImportpooldataModule { }
